import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的查理宝任务分类ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入查理宝任务分类名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
}



// WEBPACK FOOTER //
// ./src/views/clb-product-category/clb-product-category.rules.js